import { PageDataParams } from './page-data';

import {
  TagResult,
  RawDiscoursePageData,
  RawDiscourseFixedPageData,
} from '../common/page-data';
import { DiscourseData } from './discourse-data';
import { FixedOptions } from './fixed-option-data';

export class DiscourseFixedData extends DiscourseData {
  private _fixedTagId: string;
  public get fixedTagId(): string {
    return this._fixedTagId;
  }
  public set fixedTagId(value: string) {
    this._fixedTagId = value;
  }
  protected _reason: string;
  public get reason(): string {
    return this._reason;
  }
  protected _fixedOptions: FixedOptions;
  public get fixedOptions(): FixedOptions {
    return this._fixedOptions;
  }

  private _fixedAnswer: string;
  public get answer(): string {
    return this._fixedAnswer;
  }

  private get fixedCorrect(): boolean {
    return this.fixedOptions[this.answer]?.selected;
  }

  public get score(): number {
    const annotations = this.annotations;
    const score =
      annotations.reduce((result, annotation): number => {
        const answer = this.answers[annotation.id];
        const correct = !!answer && answer === annotation.tag;
        return correct ? ++result : result;
      }, 0) + (this.fixedCorrect ? 1 : 0);

    return score / (annotations.length + 1);
  }

  public get tagResults(): TagResult[] {
    const tagResults: TagResult[] = [];
    const annotations = this.annotations;

    annotations.forEach((annotation) => {
      const answer = this.answers[annotation.id];
      if (answer) {
        const correct = !!answer && answer === annotation.tag;
        const tag = this.tags[answer];
        tagResults.push({ tagId: answer, name: tag?.name || '', correct });
      }
    });

    tagResults.push({
      tagId: this.fixedTagId,
      name: this.tags[this.fixedTagId]?.name,
      correct: this.fixedCorrect,
    });

    return tagResults;
  }

  public get rawData(): RawDiscoursePageData {
    const playStats = this.playStats;

    const raw: RawDiscourseFixedPageData = {
      ...(this._rawPageData as RawDiscourseFixedPageData),
      answers: this.answers,
      playStats,
    };

    return raw;
  }

  public reset(): void {
    this.answers = {};
  }

  public constructor(params: PageDataParams) {
    super(params);

    const { rawPageData } = params;
    const {
      fixedOptionInfo: { question, fixedOptions, answer, reason, tagId },
    } = rawPageData as RawDiscourseFixedPageData;
    this._fixedOptions = fixedOptions;
    this._fixedAnswer = answer;
    this._reason = reason;
    this._fixedTagId = tagId;
    this._question = question;
  }
}
